// extracted by mini-css-extract-plugin
export var infoRow = "_u4-2";
export var labelContainer = "_u4-0";
export var rightInfo = "_u4-1";